import {Shape} from './shape';
import {AhmService} from '../../../../services/ahm.service';

export class Star extends Shape {

  private color = 'yellow';
  // private x = 150;
  // private y = 150;
  // private z = 60;

  public name = 'Heart';
  public type = 'THP.AHM1';
  // public id;

  constructor(private ctx: CanvasRenderingContext2D, private localName = 'heart', private x:number = 150, private y:number = 150, private z:number = 60, public id:string = 'shape_' + AhmService.prototype.makeid(10)) {
    super();
    this.name = localName;
    /*if (null == this.id) {
      this.id = 'shape_' + super.makeid(10);
    }*/
    // this.id = new Date().getMilliseconds();
  }

  // draw(x: number, y: number, z: number) {
  //   this.ctx.fillRect(z * x, z * y, z, z);
  // }

  draw() {
    this.ctx.fillStyle = this.color;
    this.drawStar(this.x + this.z/2 + 20 ,this.y + this.z/2 + 20,5,this.z,this.z - 25);
    this.setText();
  }

  setText() {
    this.ctx.fillStyle = "#00F";
    this.ctx.strokeStyle = "#F00";
    this.ctx.font = "italic 10pt Arial";
    this.ctx.fillText(this.name, this.x + 30, this.y + 50);
  }

  drawOnDefPosition() {
    this.ctx.fillStyle = this.color;
    this.drawStar(this.x + this.z/2 + 20 ,this.y + this.z/2 + 20,5,this.z,this.z - 25);
    this.setText();
  }

  setName(name) {
    this.name = name;
  }

  // todo: may be useless because background redraw all
  removePicture() {
    this.drawStar(this.x + this.z/2 + 20 ,this.y + this.z/2 + 20,5,this.z,this.z - 25, 'black', 'black');
  }

  drawOnPosition(xx, yy) {
  }

  putThisCoords(xx, yy) {
    this.removePicture();
    this.x = xx;
    this.y = yy;
  }

  moveRight() {
    this.removePicture();
    this.x += 10;
    this.draw();
  }

  moveLeft() {
    this.removePicture();
    this.x -= 10;
    this.draw();
  }

  moveUp() {
    this.removePicture();
    this.y -= 10;
    this.draw();
  }

  moveDown() {
    this.removePicture();
    this.y += 10;
    this.draw();
  }

  drawStar(cx,cy,spikes,outerRadius,innerRadius, insideColor='blue', borderColor='skyblue'){
    let rot=Math.PI/2*3;
    let x=cx;
    let y=cy;
    let step=Math.PI/spikes;

    this.ctx.beginPath();
    this.ctx.moveTo(cx,cy-outerRadius)
    for(let i=0;i<spikes;i++){
      x=cx+Math.cos(rot)*outerRadius;
      y=cy+Math.sin(rot)*outerRadius;
      this.ctx.lineTo(x,y)
      rot+=step

      x=cx+Math.cos(rot)*innerRadius;
      y=cy+Math.sin(rot)*innerRadius;
      this.ctx.lineTo(x,y)
      rot+=step
    }
    this.ctx.lineTo(cx,cy-outerRadius);
    this.ctx.closePath();
    this.ctx.lineWidth=5;
    this.ctx.strokeStyle=insideColor;
    this.ctx.stroke();
    this.ctx.fillStyle=borderColor;
    this.ctx.fill();
  }

  /**
   * save object state into String
   */
  /**
   * save object state into String
   */
  serialization() {
    return ';shape,' +
        this.type + ',' +
        this.name + ',' +
        this.x + ',' +
        this.y + ',' +
        this.z + ',' +
        this.id +
        ';';
  }

}
